import { matchRestRequest } from '../utils'

export const mockGetWorkBreaks = {
  shouldMock: (request) =>
    matchRestRequest(request, /\/company\/\d+\/work\/\d+\/break$/, 'GET'),
  getResponse: async () => {
    return Promise.resolve({
      data: {
        breaks: [],
        isSelfClockedOut: true,
      },
    })
  },
}
